import { EditOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Card, Col, Input, Row, Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import { useEffect, useRef, useState } from 'react'
import AddTechnicalWorkSchedule from 'components/Modals/technicalWorkScheduleModal/AddTechnicalWorkSchedule'
import { UserData } from 'utils/helpers/encrypt-decrypt-user'
import { UserModel } from 'models/users'
import { TechnicalWorkScheduleModel } from 'models/workSchedule'
import useGetTechnicalworkSchedule from 'hooks/query/workSchedule/useGetTechnicalworkSchedule'
import i18next from 'i18next'

interface TechsSetting {
  loadingMore: boolean
  data: TechnicalWorkScheduleModel[]
  search: string
}
const options: {day: string; value: number}[] = [
    {
        day: 'monday',
        value: 1
    },
    {
        day: 'tuesday',
        value: 2
    },
    {
        day: 'wednesday',
        value: 3
    },
    {
        day: 'thursday',
        value: 4
    },
    {
        day: 'friday',
        value: 5
    },
    {
        day: 'saturday',
        value: 6
    },
    {
        day: 'sunday',
        value: 7
    },
];

const { Search } = Input;

const TechnicalWorkSchedule = () => {
  const { t } = useTranslation()
  const [openAddTechnicalWorkSchedule, setOpenAddTechnicalWorkSchedule] = useState<boolean>(false)
  const [techsSetting, setTechsSetting] = useState<TechsSetting>({
    loadingMore: false,
    data: [],
    search: "",
  })
  const [selectedTech, setSelectedTech] = useState<TechnicalWorkScheduleModel | null>(null)
  const [User, setUser] = useState<UserModel | null>(null);
  const sentinelRef = useRef<HTMLDivElement | null>(null)
  
  const Users = useGetTechnicalworkSchedule({
    search: techsSetting.search,
  })

  useEffect(() => {
    setUser(UserData.Decrypt());
  }, [UserData.Decrypt]);

  useEffect(() => {
    if (Users.status === "success") {
      const allUsers = Users.data.pages.flatMap(p => p?.data || [])
      setTechsSetting(prev => ({
        ...prev,
        loadingMore: Users.hasNextPage === false,
        data: allUsers,
      }))
    }
  }, [Users.data?.pages])

  useEffect(() => {
    if (techsSetting.loadingMore) return
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        if (Users.hasNextPage) {
          Users.fetchNextPage()
        }
      }
    }, { rootMargin: '100px' })
    if (sentinelRef.current) observer.observe(sentinelRef.current)
    return () => {
      if (sentinelRef.current) observer.unobserve(sentinelRef.current)
    }
  }, [Users.hasNextPage])

  return (
    <div style={{ padding: "10px" }}>
      <div>
        <Button
          onClick={() => setOpenAddTechnicalWorkSchedule(true)}
          type="primary"
          icon={<PlusOutlined />}
        >
          {t("add_technical_work_schedule")}
        </Button>
        <Search
          style={{
            marginTop: "10px",
            paddingLeft: "6px",
          }}
          placeholder={t("search_technical_name")}
          value={techsSetting.search}
          onChange={e => {
            const value = e.target.value;
            setTechsSetting(prev => ({
              ...prev,
              search: value,
              data: [],
            }));
          }}
        />
        <Row gutter={[16,16]} style={{textAlign: i18next.language === "en" ? "left" : "right", marginTop: "10px"}}>
          {techsSetting?.data?.map((element, index) => (
              <Col key={index} md={8} sm={12} xs={24}>
                <Card style={{height: "100%"}} title={
                  <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <p style={{margin: "0px"}}>{element?.technical_name}</p>
                    <div 
                    onClick={()=>{setOpenAddTechnicalWorkSchedule(true); setSelectedTech(element)}}
                    style={{
                      backgroundColor: "#28befa", 
                      width: "fit-content", 
                      padding: "3px 5px", 
                      borderRadius: "5px", color: "white",
                      cursor: "pointer"
                      }}>
                      <EditOutlined />
                    </div>
                  </div>
                } variant="borderless">
                  <div>
                    <p>{t("start_time")} : {element?.start_time}</p>
                    <p>{t("end_time")} : {element?.end_time}</p>
                    <div style={{display: "flex", gap: "5px", flexWrap: "wrap"}}>
                        <p>{t("work_days")} : </p>
                        {element?.day_of_week?.map((num) => {
                          const dayObj = options.find((opt) => opt.value === num);
                          return dayObj ? <p key={dayObj.value}>{t(dayObj.day)} - </p> : null;
                        })}
                    </div>
                  </div>
                </Card>
              </Col>
          ))}
        </Row>
        <div ref={sentinelRef}></div>

        {(Users.isLoading || Users.isFetching) 
          ?       
            <div style={{ textAlign: "center", padding: "20px 0" }}>
              <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
            </div>
          : <></>  
        }

        <AddTechnicalWorkSchedule
          openAddTechnicalWorkSchedule={openAddTechnicalWorkSchedule}
          setOpenAddTechnicalWorkSchedule={setOpenAddTechnicalWorkSchedule}
          selectedTech={selectedTech}
          setSelectedTech={setSelectedTech}
        />
      </div>
    </div>
  )
}

export default TechnicalWorkSchedule
